<template>
<div class="open-type">
  <div class="file-type" v-if="component.type == 'file_upload'">
    <label v-show="uploadStatus == 'select' || (allowMultiple && uploadedUrls.length > 0 && uploadedUrls.length < fileLimits.maxFiles)" class="file-upload tabable" :for="'file-chooser-' + component.id" tabindex="-1">{{ messages.upload_file }}</label>

    <input type="file" @change="processFile($event)" :id="'file-chooser-' + component.id" class="fileUpload" tabindex="-1" :multiple="allowMultiple" :disabled="allowMultiple && uploadedUrls.length >= fileLimits.maxFiles">

    <div v-if="uploadStatus == 'upload'" class="uploadProgress">{{ messages.uploading }} <inlineLoading></inlineLoading></div>

    <template v-if="uploadStatus == 'uploaded' || (allowMultiple && uploadedUrls.length > 0)">
      <div v-if="!allowMultiple" class="uploadedFile"><a :href="uploadedUrl" class="file" target="_blank" rel="noopener">{{ uploadedFileNames[0] || messages.file_uploaded }}</a><button @click="removeFile" class="fileRemove"><i class="icon-close"></i></button></div>
      <div v-else class="uploadedFiles">
        <div v-for="(url, index) in uploadedUrls" :key="index" class="uploadedFile">
          <a :href="url" class="file" target="_blank" rel="noopener">{{ uploadedFileNames[index] || (messages.file_uploaded + ' ' + (index + 1)) }}</a>
          <button @click="removeFileAtIndex(index)" class="fileRemove" type="button" :aria-label="messages.clear"><i class="icon-close"></i></button>
        </div>
      </div>
    </template>

  </div>
  <small class="error" v-if="component.type == 'file_upload'" v-show="component.required_show_label || fileUploadError">{{ fileUploadError || uploadErrorMessage }}</small>


  <div v-if="this.component.type == 'signature'" class="badge"><i class="signature"></i></div>
  <div v-if="component.type == 'signature'" ref="signature" class="signature-preview">
    <canvas :width="signatureWidth" height="200px" :id="'signature-' + component.id"></canvas>

    <div  class="signature-buttons">
      <div class="button-wrapper">
        <button @click="clearSignature" class="button-first">{{ messages.clear }}</button>
      </div>
      <div class="button-wrapper">
        <button v-if="uploadStatus == 'select'" @click="processFile">{{ messages.confirm }}</button>
        <button v-if="uploadStatus == 'upload'">{{ messages.uploading }} <inlineLoading></inlineLoading></button>
        <button v-if="uploadStatus == 'uploaded'" disabled>{{ messages.file_uploaded }}</button>
      </div>
    </div>
  </div>
  <small class="error" v-if="this.component.type == 'signature'" v-show="component.required_show_label">{{messages.answer_is_required}}</small>


</div>
</template>
<script>
import Vue from 'vue'
import { store } from '../store'
import axios from 'axios'
import inlineLoading from './inlineLoading'
import SignaturePad from 'signature_pad'

// Fallbacks mirroring config/file-uploads.php, used when the form page was served
// without the team limits.
const DEFAULT_MAX_SIZE = 1024 * 1024 * 5
const DEFAULT_MAX_FILES = 5
const DEFAULT_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'tif', 'tiff', 'pdf', 'doc', 'docx', 'odt', 'rtf', 'txt', 'xls', 'xlsx', 'ods', 'csv', 'ppt', 'pptx', 'zip', 'rar', '7z', 'xml', 'mp3']

export default {
  name: 'uploadType',
  props: ['component', 'formId'],
  components: {
    inlineLoading
  },
  data: function () {
    return {
      store: store,
      uploadStatus: 'select',
      selectedFile: '',
      uploadedUrl: '',
      uploadedUrls: [],
      uploadedFileIds: [],
      uploadedFileNames: [],
      messages: window.form.messages,
      signaturePad: null,
      signatureWidth: '300px',
      fileUploadError: '',
    }
  },
  computed: {
    allowMultiple: function () {
      return this.component.type === 'file_upload' && this.component.properties && this.component.properties.allow_multiple_files === true
    },
    fileLimits: function () {
      let configured = (window.plan && window.plan.file_upload) || {}
      let extensions = configured.allowed_extensions && configured.allowed_extensions.length
        ? configured.allowed_extensions
        : DEFAULT_ALLOWED_EXTENSIONS
      return {
        maxSize: configured.max_size || DEFAULT_MAX_SIZE,
        maxFiles: configured.max_files || DEFAULT_MAX_FILES,
        allowedExtensions: extensions.map(function (extension) { return String(extension).toLowerCase() })
      }
    },
    uploadErrorMessage: function () {
      return this.withLimit(this.messages.upload_error, Math.round(this.fileLimits.maxSize / (1024 * 1024)))
    },
    fileTypeErrorMessage: function () {
      return this.messages.file_type_not_allowed || 'This file type is not allowed.'
    },
    maxFilesErrorMessage: function () {
      return this.withLimit(this.messages.max_files_exceeded || 'Max. 5 files.', this.fileLimits.maxFiles)
    }
  },
  created: function () {
    Vue.set(this.component, 'required_show_label', false)
    Vue.set(this.component, 'is_focused', false)
  },
  mounted: function () {
    this.createSignaturePad()
  },
  watch: {
    component: {
      handler: function(val) {
        if (val.is_focused == false) {
          if (this.component.is_valid == false) {
            Vue.set(this.component, 'required_show_label', 1)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    fileExtension: function (file) {
      let parts = String(file.name || '').split('.')
      if (parts.length < 2) {
        return ''
      }

      return String(parts.pop()).toLowerCase()
    },
    isAllowedExtension: function (file) {
      let extension = this.fileExtension(file)

      return extension !== '' && _.includes(this.fileLimits.allowedExtensions, extension)
    },
    isAllowedSize: function (file) {
      return file.size <= this.fileLimits.maxSize
    },
    isFileAccepted: function (file) {
      return this.isAllowedSize(file) && this.isAllowedExtension(file)
    },
    serverErrorMessage: function (code) {
      if (code === 'file_too_large') {
        return this.uploadErrorMessage
      }
      if (code === 'file_type_not_allowed') {
        return this.fileTypeErrorMessage
      }

      return code
    },
    withLimit: function (message, limit) {
      if (!message) {
        return message
      }

      return String(message).replace(/\d+/, limit)
    },
    processFile: function (event) {
      let self = this
      if (this.component.type === 'signature') {
        if (this.signaturePad.isEmpty()) {
          Vue.set(this.component, 'is_valid', false)
          Vue.set(this.component, 'required_show_label', 1)
          return
        }
        let dataUrl = this.signaturePad.toDataURL()
        this.selectedFile = this.dataURLtoFile(dataUrl, 'signature.png')
      }
      if (this.component.type === 'file_upload') {
        let files = this.allowMultiple && event.target.files && event.target.files.length
          ? Array.from(event.target.files)
          : (event.target.files && event.target.files[0] ? [event.target.files[0]] : [])
        let maxFiles = this.fileLimits.maxFiles
        if (this.allowMultiple && files.length > maxFiles) {
          this.fileUploadError = this.maxFilesErrorMessage
          Vue.set(this.component, 'is_valid', false)
          Vue.set(this.component, 'required_show_label', 1)
          document.getElementById('file-chooser-' + this.component.id).value = ''
          return
        }
        if (this.allowMultiple && this.uploadedFileIds.length + files.length > maxFiles) {
          this.fileUploadError = this.maxFilesErrorMessage
          Vue.set(this.component, 'is_valid', false)
          Vue.set(this.component, 'required_show_label', 1)
          document.getElementById('file-chooser-' + this.component.id).value = ''
          return
        }
        this.fileUploadError = ''
        if (files.length === 0) {
          Vue.set(this.component, 'is_valid', false)
          Vue.set(this.component, 'required_show_label', 1)
          return
        }
        let tooLarge = files.some(function (file) { return !self.isAllowedSize(file) })
        let invalidType = files.some(function (file) { return !self.isAllowedExtension(file) })
        if (tooLarge || invalidType) {
          this.fileUploadError = tooLarge ? this.uploadErrorMessage : this.fileTypeErrorMessage
          Vue.set(this.component, 'is_valid', false)
          Vue.set(this.component, 'required_show_label', 1)
          document.getElementById('file-chooser-' + this.component.id).value = ''
          return
        }
        Vue.set(this.component, 'is_valid', true)
        Vue.set(this.component, 'required_show_label', 0)
        this.$emit('verifyPage')
        this.uploadStatus = 'upload'
        let existingIds = this.allowMultiple ? this.uploadedFileIds.slice() : []
        let existingHrefs = this.allowMultiple ? this.uploadedUrls.slice() : []
        let existingNames = this.allowMultiple ? this.uploadedFileNames.slice() : []
        self.uploadFilesSequentially(files, existingIds, existingHrefs, function (fileIds, hrefs) {
          self.uploadStatus = 'uploaded'
          self.uploadedUrl = hrefs[0]
          self.uploadedUrls = hrefs
          self.uploadedFileIds = fileIds
          self.uploadedFileNames = existingNames.concat(files.map(function (f) { return f.name }))
          let answerObject = {
            component: { id: self.component.id, type: self.component.type },
            type: 'file_name',
            file_ids: fileIds
          }
          Vue.set(self.store.answers, self.component.ref, answerObject)
        }, function () {
          self.uploadStatus = 'select'
          Vue.delete(self.store.answers, self.component.ref)
          if (self.component.validations.required) {
            Vue.set(self.component, 'is_valid', false)
            Vue.set(self.component, 'required_show_label', 1)
          }
        })
        document.getElementById('file-chooser-' + this.component.id).value = ''
        return
      }

      if (this.selectedFile && this.isFileAccepted(this.selectedFile)) {
        Vue.set(this.component, 'is_valid', true)
        Vue.set(this.component, 'required_show_label', 0)
        this.$emit('verifyPage')
        this.uploadStatus = 'upload'
        let formData = new FormData()
        formData.append('file', this.selectedFile)
        formData.append('formId', this.formId)
        if (this.component.id) {
          formData.append('component_id', this.component.id)
        }
        let config = {
          method: 'post',
          mode: 'no-cors',
          headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data' },
          withCredentials: true,
          credentials: 'same-origin'
        }
        axios.post(window.file_upload_url, formData, config)
          .then(function (response) {
            self.uploadStatus = 'uploaded'
            self.uploadedFileNames = [self.selectedFile.name]
            let fileId = response.data.file_id
            self.uploadedFileIds = fileId ? [fileId] : []
            self.uploadedUrl = response.data.href
            Vue.set(self.store.answers, self.component.ref, {
              component: { id: self.component.id, type: self.component.type },
              type: 'file_name',
              file_ids: fileId ? [fileId] : []
            })
          })
          .catch(function () {
            self.uploadStatus = 'select'
            Vue.delete(self.store.answers, self.component.ref)
            if (self.component.validations.required) {
              Vue.set(self.component, 'is_valid', false)
              Vue.set(self.component, 'required_show_label', 1)
            }
          })
      } else {
        Vue.set(this.component, 'is_valid', false)
        Vue.set(this.component, 'required_show_label', 1)
      }
    },
    uploadFilesSequentially: function (files, collectedFileIds, collectedHrefs, onSuccess, onError) {
      let self = this
      if (files.length === 0) {
        onSuccess(collectedFileIds, collectedHrefs)
        return
      }
      let file = files[0]
      let formData = new FormData()
      formData.append('file', file)
      formData.append('formId', this.formId)
      if (this.component.id) {
        formData.append('component_id', this.component.id)
      }
      let config = {
        method: 'post',
        mode: 'no-cors',
        headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
        credentials: 'same-origin'
      }
      axios.post(window.file_upload_url, formData, config)
        .then(function (response) {
          let fileId = response.data.file_id
          let href = response.data.href
          let nextIds = fileId ? collectedFileIds.concat([fileId]) : collectedFileIds
          let nextHrefs = collectedHrefs.concat([href])
          if (files.length === 1) {
            onSuccess(nextIds, nextHrefs)
          } else {
            self.uploadFilesSequentially(files.slice(1), nextIds, nextHrefs, onSuccess, onError)
          }
        })
        .catch(function (err) {
          let serverError = err.response && err.response.status === 400 && err.response.data ? err.response.data.error : null
          if (serverError) {
            self.fileUploadError = self.serverErrorMessage(serverError)
            Vue.set(self.component, 'required_show_label', 1)
          }
          onError()
        })
    },
    removeFile: function () {
      this.uploadStatus = 'select'
      Vue.delete(this.store.answers, this.component.ref)
      this.uploadedUrl = ''
      this.uploadedUrls = []
      this.uploadedFileIds = []
      this.uploadedFileNames = []
      this.selectedFile = ''
      this.fileUploadError = ''
    },
    removeFileAtIndex: function (index) {
      this.uploadedUrls.splice(index, 1)
      this.uploadedFileIds.splice(index, 1)
      this.uploadedFileNames.splice(index, 1)
      if (this.uploadedUrls.length === 0) {
        this.removeFile()
        return
      }
      Vue.set(this.store.answers, this.component.ref, {
        component: { id: this.component.id, type: this.component.type },
        type: 'file_name',
        file_ids: this.uploadedFileIds.slice()
      })
      this.uploadedUrl = this.uploadedUrls[0]
    },
    createSignaturePad() {
      if ( this.component.type == 'signature') {
        const canvas = document.getElementById("signature-" + this.component.id)
        let width = this.$refs.signature.clientWidth
        this.signatureWidth = width + 'px'

        const signaturePad = new SignaturePad(canvas, {
          minWidth: 3,
          maxWidth: 5,
          background: '#ffffff',
        })
        signaturePad.addEventListener("endStroke", () => {
          this.inputValue = 'x'
          // this.updateData()
        });
        this.signaturePad = signaturePad
        window.addEventListener("resize", this.resizeCanvas);
      }
    },
    clearSignature() {
      this.signaturePad.clear()
      this.inputValue = null
      this.removeFile()
      // this.updateData()
    },
    resizeCanvas() {
      let width = this.$refs.signature.clientWidth
      this.signatureWidth = width + 'px'
      this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
  }
}
</script>